import { cx } from '../../lib/cx';

export interface FilterChipsProps<T extends string> {
  options: { value: T; label: string; count?: number }[];
  value: T;
  onChange: (value: T) => void;
  'aria-label': string;
  className?: string;
}

/** Pill filters above a list ("All · 14", "Two-step off · 5"): single choice, dark when selected (Figma A16). */
export function FilterChips<T extends string>({ options, value, onChange, className, ...rest }: FilterChipsProps<T>) {
  return (
    <div role="group" aria-label={rest['aria-label']} className={cx('flex flex-wrap gap-(--mbm-space-2)', className)}>
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
            className={cx(
              'h-(--mbm-size-button-row) rounded-full border px-(--mbm-space-4) text-label-medium focus-visible:outline-none focus-visible:shadow-(--mbm-shadow-focus-ring)',
              selected
                ? 'border-action-primary bg-action-primary text-text-on-dark'
                : 'border-border-default bg-surface-card text-text-primary',
            )}
          >
            {option.label}
            {option.count !== undefined ? ` · ${option.count}` : ''}
          </button>
        );
      })}
    </div>
  );
}
